import { useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { updatePassword } from '../api/updatePassword';

const usePasswordForm = () => {
    let newPassword = useRef({});
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
        reset
    } = useForm();

    newPassword.current = watch('newPassword', '');

    const validatePasswordConfirmation = (value) => value === newPassword.current;

    const onUpdatePassword = (t) => async ({ newPassword }) => {
        setIsLoading(true);

        const onFail = () => {
            setShowErrorModal(true);
        };

        const res = await updatePassword({ t, newPW: newPassword }, onFail);
        console.log("Successful",res);
        

        setIsLoading(false);

        if (res?.status == 201) setShowSuccessModal(true);
    };

    const onCloseErrorModal = () => setShowErrorModal(false);
    const onCloseSuccessModal = () => {
        setShowSuccessModal(false);
        reset();
    };
    const onCloseErrorMessage = () => setShowErrorModal(false);

    return {
        register,
        handleSubmit,
        errors,
        validatePasswordConfirmation,
        isLoading,
        showErrorModal,
        showSuccessModal,
        onUpdatePassword,
        onCloseErrorModal,
        onCloseSuccessModal,
        onCloseErrorMessage
    };
};


export default usePasswordForm;
